import React from 'react';
import PlayerAdminList from './PlayerAdminList';

function PlayersAdmin(props) {
    const { players, id } = props;
    return (<div>
        {players ?
            <PlayerAdminList
                players={players}
                id={id}
            />
            : 'loading...'
        }
    </div>);
}

export default PlayersAdmin;